import { onMounted } from "vue";
import useThemeSwitcher from "@shared/use/useThemeSwitcher";

export default () => {
  const themeSwitcher = useThemeSwitcher();
  onMounted(() => {
    themeSwitcher.switchTheme("light");
  });
};
